import React, { lazy, Suspense, memo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { ConfigProvider } from 'antd';
import Loading from 'components/shared-components/Loading';
import { lightTheme, darkTheme } from 'configs/ThemeConfig';
import { resources } from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import Routes from 'routes'
import { useMaffleSso } from '@maffle/common-fe';
import { signInFromShell } from 'store/slices/authSlice';
import { AUTH_TOKEN } from 'constants/AuthConstant';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

// Origin della dashboard Maffle ammesso per l'SSO (undefined = qualsiasi, solo dev).
const MAFFLE_SHELL_ORIGIN = process.env.REACT_APP_MAFFLE_SHELL_ORIGIN;

const Layouts = () => {

	const dispatch = useDispatch();
	const token = useSelector(state => state.auth.token);

	// SSO shell Maffle: se la dashboard ci embedda, riceviamo il JWT e idratiamo
	// la sessione (login saltato). Fuori dall'iframe è un no-op.
	useMaffleSso({
		allowedOrigins: MAFFLE_SHELL_ORIGIN ? [MAFFLE_SHELL_ORIGIN] : undefined,
		getToken: () => localStorage.getItem(AUTH_TOKEN),
		signInWithToken: async (shellToken, user) => {
			await dispatch(signInFromShell({ token: shellToken, user })).unwrap();
		},
	});

	const expirationDate = token!=null ? new Date(JSON.parse(atob(token?.split('.')[1])).exp * 1000): null;
	const currentDate = new Date();

	const blankLayout = useSelector(state => state.theme.blankLayout);

	const Layout = token && !blankLayout && currentDate<=expirationDate ? AppLayout : AuthLayout;

	const locale = useSelector(state => state.theme.locale);

	const direction = useSelector(state => state.theme.direction);

	const currentTheme = useSelector(state => state.theme.currentTheme);

	const currentAppLocale = resources[locale];

	useBodyClass(`dir-${direction}`);

	const themeConfig = currentTheme === 'light' ? {...lightTheme} : {...darkTheme}

	return (
		<ConfigProvider theme={themeConfig} direction={direction} locale={currentAppLocale.antd}>
			<Suspense fallback={<Loading cover="content"/>}>
				<Layout>
					<Routes />
				</Layout>
			</Suspense>
		</ConfigProvider>
	)
}

export default memo(Layouts)